import type * as React from 'react';

import type { DocumentMarkColor } from '@gitbook/api-client';
import type { MarkProps } from '@gitbook/slate-react';

import { useContentEditorColor } from '../colors/ContentEditorColorContext';

function resolveCSSColor(color: string | undefined): string {
    return color || 'inherit';
}

/**
 * Renderer for a color editor mark.
 */
export function MarkColor(props: MarkProps): React.ReactElement {
    const { children, mark, attributes } = props;
    const data = mark.data.toFrozenObject() as DocumentMarkColor['data'];
    const textColor = useContentEditorColor({ type: 'text', color: data?.text ?? null });
    const backgroundColor = useContentEditorColor({
        type: 'background',
        color: data?.background ?? null,
    });

    return (
        <mark
            style={{
                color: resolveCSSColor(textColor?.color),
                backgroundColor: resolveCSSColor(backgroundColor?.color),
            }}
            {...attributes}
        >
            {children}
        </mark>
    );
}
